































































































































































export default
    methods:
        demo: ->
            this.$router.push { name: 'events'}
